import React, { useEffect } from 'react';
import { BsGithub } from 'react-icons/bs';
import { FaEye } from 'react-icons/fa';
import { FaHtml5, FaBootstrap } from 'react-icons/fa';

import { SiCss3 } from 'react-icons/si';


import img1 from '../../../images/project-details/wedding-bell/resized/1.png';
import img2 from '../../../images/project-details/wedding-bell/resized/2.png';
import img3 from '../../../images/project-details/wedding-bell/resized/3.png';
import img4 from '../../../images/project-details/wedding-bell/resized/4.png';



import AOS from 'aos';
import 'aos/dist/aos.css';
import { Link } from 'react-router-dom';



import WeddingBellLarge from '../../../images/projects-large-image/WeddingBell.png';
import useTitle from '../../../Hooks/useTitle';











const WeddingBellDetails = () => {


    useTitle('Project | Wedding Bell')

    useEffect(() => {
        AOS.init({
            duration: 1500
        })
    }, [])


    //details er 1st pic er moddhe hover kole ekta smooth transition hobe and full pic ta scroll hoye show korbe
    const divStyle = {
        backgroundImage: ` url(${WeddingBellLarge})`,
        transition: 'ease 4s'
    };
    const handleHover = () => {
        divStyle.transition = 'ease 4s'
    };
    const handleUnHover = () => {
        divStyle.transition = 'ease 1s'
    };





    return (
        <div>
            <div>


                <div className='flex justify-center items-center md:flex-row lg:flex-row sm:flex-col-reverse flex-col-reverse lg:mb-10 md:mb-0 sm:mb-8 mb-8 mt-16'>
                    <h1 className='uppercase text-center text-2xl sm:text-2xl md:text-3xl lg:text-3xl  animation lg:mt-0 md:mt-0 sm:mt-10 mt-10' data-aos='flip-right'>Wedding <span className='text-rose-600 text-5xl'>Bell</span></h1>
                </div>


                <div className='grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 gap-x-10  gap-y-8 mt-8 mb-24 animation' data-aos='flip-left'>


                    <div className='lg:w-[460px] md:w-[335px] sm:w-[355px] w-[355px]  mx-auto' >
                        <div
                            style={divStyle}
                            onMouseEnter={handleHover}
                            onMouseLeave={handleUnHover}
                            className=" bg-top bg-cover  hover:bg-bottom rounded-lg  lg:w-[460px] lg:h-[308px] md:w-[330px] md:h-[220px] sm:w-[338px] sm:h-[220px] w-[338px] h-[220px] mx-auto"></div>
                    </div>



                    <div className="card    mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg' src={img1} alt="car!" />
                    </div>

                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 ">
                        <img className='rounded-lg ' src={img2} alt="car!" />
                    </div>

                    <div className="card  mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img3} alt="car!" />
                    </div>

                    <div className="card mx-auto lg:w-[460px] lg:h-[308px] md:w-[335px] sm:w-[345px] w-[345px] transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300">
                        <img className='rounded-lg ' src={img4} alt="car!" />
                    </div>

                </div>





                <div>
                    <h1 className='uppercase my-10 text-center text-3xl sm:text-3xl md:text-5xl lg:text-5xl font-mono text-cyan-600 font-bold ' >Features & Source Code
                    </h1>

                    <div className="flex justify-evenly  lg:flex-row md:flex-col-reverse sm:flex-col-reverse flex-col-reverse lg:mx-0 md:mx-8 sm:mx-4 mx-3 mb-24 gap-x-10">

                        {/* <div className="bg-gray-800 px-6 py-6 rounded-2xl shadow-2xl w-full sm:w-full md:w-full lg:w-2/4">

                            <h1 className='text-justify text-lg' > ⚪ Short Quiz Mania is a quiz project that helps the students to take part in quizzes of different subjects. For the sake of this project I have added 4 subjects for quizzes for the time being. But it will be updated very soon.</h1> <br></br>

                            <h1 className='text-justify text-lg '> ⚪ This website is made by using React Router DOM. and for styling I have used bootstrap and some custom css. By click the nav links the website redirects to the respected url. All the data are fetched from API ans display on UI. For the right and wrong answers we have added React Toastify for better user experience. </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ The project shows different quiz subjects with some of the question for each subject. If any student clicks on a answer then a toaster will appear and display whether the answer is right or wrong.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ By clicking on the eye icon that is located on the right side of each question one can see the correct answer easily. </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪  Besides the project contains the statistics chart that shows the number of question respected to the subject name. If someone clicks on the blog section then the url redirects him/her to some of the frequently asked questions that we got.
                            </h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ the website also shows the active route with a different color on the nav bar. so that user can understand which route he/she is visiting. If someone wants to visit a route which is not assigned then an error message will be shown.</h1> <br></br>

                            <h1 className='text-justify text-lg'> ⚪ By clicking on the about link the user we find the courses that we provide. They can also find the course instructors details.
                            </h1>

                        </div> */}


                        <div className='w-full sm:w-full md:w-full lg:w-2/4'>

                            <h2 className='text-center text-3xl mt-4 mb-12'>GitHub Links <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                            <div className=''>

                                <a href='https://fahimsakib1.github.io/marriage-website-bootstrap-responsive-practice/' target='blank' title='Live Site Demo'>
                                    <div className='relative group mt-4 animation' data-aos='fade-left'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-gradient-to-r from-pink-600 to-violet-400 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>Live Website</span>
                                                <FaEye className='text-3xl text-white'></FaEye>
                                            </div>
                                        </button>
                                    </div>
                                </a>



                                <a href='https://github.com/Fahimsakib1/marriage-website-bootstrap-responsive-practice' target='blank' title='GutHub Code'>
                                    <div className='relative group mt-4 animation' data-aos='fade-right'>
                                        <div className='absolute -inset-0.5 mt-4 rounded-xl blur bg-green-500 opacity-60 group-hover:opacity-90 transition duration-300 '>
                                        </div>
                                        <button type='submit' value="Submit" className='w-full py-4 text-center text-white text-2xl mt-4 bg-black rounded-xl leading-none relative transition duration-300 ease-in-out delay-150 group-hover:-translate-y-0.5 group-hover:scale-102'>
                                            <div className='flex space-x-3 justify-center items-center'>
                                                <span>GitHub Code</span>
                                                <BsGithub className='text-3xl text-white'></BsGithub>
                                            </div>
                                        </button>
                                    </div>
                                </a>



                            </div>

                            <h2 className='text-center text-3xl mt-12 mb-8 '>Technologies Used <hr className='mx-auto mt-2 border-1 border-rose-500' width="180px" /></h2>

                            <div className='flex justify-center items-center flex-wrap  gap-x-8 lg:mb-0 md:mb-8 sm:mb-12 mb-12 animation' data-aos='fade-up'>

                                <div className='border-2 border-violet-600 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaHtml5 className='text-4xl mx-2 text-orange-500'></FaHtml5>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>HTML</h1>
                                </div>

                                <div className='border-2 border-violet-600  mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <SiCss3 className='text-4xl mx-2 text-blue-500'></SiCss3>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>CSS</h1>
                                </div>

                                <div className='border-2 border-violet-600 mb-4 rounded-xl flex justify-center items-center transition ease-in-out delay-150 hover:-translate-y-2 hover:scale-110 duration-300'>
                                    <FaBootstrap className='text-4xl mx-2 text-blue-600'></FaBootstrap>
                                    <h1 className='text-white text-2xl py-2 ml-1 mr-4'>Bootstrap</h1>
                                </div>

                            </div>



                        </div>
                    </div>
                </div>





                {/* <div className='mx-auto text-center '>
                    <Link to='/'>
                        <button className='btn btn-primary w-[300px] sm:w-[300px] md:w-[400px] bg-black text-white text-xl border-2  hover:border-teal-500 border-violet-600 transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-105 duration-300 border-b-4 border-t-0 border-r-2 border-l-0 hover:bg-black hover:text-white'>Back To Home Page</button>
                    </Link>
                </div> */}




                <div className='mx-auto text-center my-10 '>
                    <Link to='/'>
                        <button className='cursor-pointer hover:scale-105 hover:duration-300 hover:ease-in-out hover:delay-150 px-6 py-2 rounded-sm  text-white text-lg mt-3 border-0 bg-blue-800' title='Download Resume'>
                            Back To Home Page
                        </button>
                    </Link>
                </div>





            </div>
        </div>
    );
};

export default WeddingBellDetails;